import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { RiMenu5Line } from "react-icons/ri";
import { IoMdArrowDropupCircle } from "react-icons/io";
import AOS from "aos";
import "aos/dist/aos.css";
import Navigation from "./Navigation";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [navBackground, setNavBackground] = useState(false);

  const handleToggleOn = () => {
    setToggle(true);
  };

  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 80) {
        setNavBackground(true);
      } else {
        setNavBackground(false);
      }
    };
    window.addEventListener("scroll", changeBackground);
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      {toggle ? (
        <Navigation setToggle={setToggle} />
      ) : (
        <Container>
          <nav className={navBackground ? `active` : ""}>
            <div className="inner-circle">
              <div className="circle-animation">
                <RiMenu5Line onClick={handleToggleOn} />
              </div>
            </div>
          </nav>
        </Container>
      )}

      <a href="#secTop">
        <MYIoMdArrowDropupCircle />
      </a>
    </>
  );
};

export default Navbar;

const Container = styled.header`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;

  nav {
    width: 100%;
    height: 5rem;
    display: grid;
    place-content: center;
  }

  .inner-circle {
    content: "";
    background: #000;
    background-color: ${(props) => props.theme.light.primary};
    width: 4em;
    height: 4em;
    border-radius: 50%;
    z-index: 1;
    box-shadow: 0 0 1em rgba(0, 0, 0, 0.8);
    display: grid;
    place-content: center;

    @media (prefers-color-scheme: light) {
      background-color: ${(props) => props.theme.light.text};
    }

    svg {
      color: ${(props) => props.theme.dark.custom};
      font-size: 1.3em;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.1) skew(35deg);
      }
    }
  }

  .circle-animation {
    display: grid;
    place-content: center;
    width: 4em;
    height: 4em;
    border-radius: 50%;
    animation-name: button-pulse;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;

    @keyframes button-pulse {
      0% {
        border: none;
      }
      25% {
        border: 2px solid ${(props) => props.theme.dark.custom};
      }
      50% {
        border: 4px solid ${(props) => props.theme.dark.primary};
      }
      75% {
        border: 2px solid ${(props) => props.theme.dark.custom};
      }
      100% {
        border: none;
      }
    }
  }

  .active {
    transition: all 0.3s;
    background: ${({ theme }) => theme.light.navBackground};
  }
`;

const MYIoMdArrowDropupCircle = styled(IoMdArrowDropupCircle)`
  font-size: 2rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  color: ${(props) => props.theme.dark.custom};
  transition: transform 0.3s;

  :hover {
    transform: scale(1.2);
  }
`;
